var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detail-container"},[_c('DForm',{ref:"formRef",attrs:{"model":_vm.formModel,"formItems":_vm.formItems,"label-width":"140px"}}),_c('div',{staticClass:"submit-button"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.handleSubmit}},[_vm._v("提交")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }